import config from '../../../config';
import { getHeaders } from '../../Auth/TokenManager';

export const fetchPromotionGroup = slug =>
  $.ajax({
    url: `${config.localeApi}/promotion_groups/${slug}`,
    dataType: 'json',
    headers : getHeaders()
  });

export const fetchPromotionTnC = slug =>
  $.ajax({
    url: `${config.localeApi}/promotions/${slug}`,
    dataType: 'json',
  });



// WEBPACK FOOTER //
// ./src/Common/Providers/PromotionGroupApi.js